import {
  collection as testScriptCollection,
  schema as testScriptSchema,
  create as createTestScript,
} from './testScript'

import {
  collection as lintScriptCollection,
  schema as listScriptSchema,
  create as createLintScript,
} from './lintScript'

import {
  collection as fixScriptCollection,
  schema as fixScriptSchema,
  create as createFixScript,
} from './fixScript'

export const TEST_SCRIPT = {
  collection: testScriptCollection,
  schema: testScriptSchema,
  create: createTestScript,
}

export const LINT_SCRIPT = {
  collection: lintScriptCollection,
  schema: listScriptSchema,
  create: createLintScript,
}

export const FIX_SCRIPT = {
  collection: fixScriptCollection,
  schema: fixScriptSchema,
  create: createFixScript,
}
